import axiosInstance from "./Axios";
import baseURL from "../config/config";

const ENDPOINT = `${baseURL}/api/classroom/reading-events/`;
const FLUSH_MS = 5000;
const MAX_BATCH = 50;
const MAX_QUEUE = 300;

let queue = []; // { sessionId, event }
let timer = null;
let flushing = false;

const makeId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

const schedule = () => {
  if (timer) return;
  timer = setTimeout(() => {
    timer = null;
    flushReadingEvents();
  }, FLUSH_MS);
};

export const flushReadingEvents = async () => {
  if (flushing || queue.length === 0) return;
  flushing = true;
  const sessionId = queue[0].sessionId;
  const batch = [];
  const rest = [];
  for (const item of queue) {
    if (item.sessionId === sessionId && batch.length < MAX_BATCH) {
      batch.push(item);
    } else {
      rest.push(item);
    }
  }
  queue = rest;

  try {
    await axiosInstance.post(ENDPOINT, {
      session_id: sessionId,
      events: batch.map((b) => b.event),
    });
  } catch (e) {
    const code = e?.response?.status;
    // Client errors will never succeed on retry; network/5xx errors will.
    if (!code || code >= 500) {
      queue = [...batch, ...queue].slice(-MAX_QUEUE);
    }
  } finally {
    flushing = false;
    if (queue.length > 0) schedule();
  }
};

/**
 * Queue one classroom-reading event. Best effort: never throws.
 * details.student_id and details.reading_content_id are lifted to top level,
 * everything else goes into the payload. Send ids and small facts only, no names.
 */
export const logReadingEvent = (sessionId, type, details = {}) => {
  try {
    if (!sessionId || !type) return;
    const { student_id, reading_content_id, ...payload } = details;
    queue.push({
      sessionId: Number(sessionId),
      event: {
        client_event_id: makeId(),
        type,
        ts: new Date().toISOString(),
        student_id: student_id ?? null,
        reading_content_id: reading_content_id ?? null,
        payload,
      },
    });
    if (queue.length > MAX_QUEUE) queue.shift();
    if (queue.length >= MAX_BATCH) {
      flushReadingEvents();
    } else {
      schedule();
    }
  } catch (e) {
    // analytics must never break the classroom
  }
};

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", () => {
    flushReadingEvents();
  });
}